module.exports = __webpack_public_path__ + "static/media/TRADE-BNB.8e097272.svg";